export default {
    data() {
        return {
            labels: null,
            tips: '',
            isContinue: true,
            isContinues: true,
            classDetails: {
                period: '',
                image: '',
                name: '',
                price: '',
                onsale: '',
                teacher: ' ',
                desc: '',
                // project_id: '',
            },
            shoppingArr: [],
            labels: {
                id: '0'
            },
            labelsNoFirst: [],
            resources: [],
        }
    },
    methods: {
        mouseOver(index, i) {
            this.$refs['btn' + index + i][0].style.background = "#DCECFD";
        },
        mouseLeave(index, i) {
            this.$refs['btn' + index + i][0].style.background = "#ffffff";
        },
        //判断是否已经购买过该课程
        byNow: function (productId, price) {
            if (Number.parseFloat(price) == 0) {
                this.$post('orders/create', {
                    token: this.$store.state.id,
                    products: '[' + productId + ']',
                    pay_type: 1,
                    shop_id: this.$store.state.store.id
                }).then(res => {
                    if (res.data.status == 'success') {
                        return res.data.result;
                    }
                }).then(id => {
                    let time = this.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
                    this.$post('orders/cancel', { id: id, token: this.$store.state.id, state: '2', pay_date: time }).then(res => {
                        if (res.data.status == 'success') {
                            UIkit.modal(document.querySelector('#modal-free-class')).show();
                            this.$router.push({
                                path: '/personalcenter',
                            });
                        }
                    })
                })
            } else {
                let commodityList = [];
                let totalprices = price;
                commodityList.push(productId)
                this.$router.push({
                    path: '/pay',
                    query: {
                        commodityList: JSON.stringify(commodityList),
                        totalprices: totalprices,
                    }
                });
            }
        },

        //转化时间格式 yyyy-MM-dd hh:mm:ss
        formatDate: function (date, fmt) {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
                }
            }
            return fmt;
        },
        //转化时间格式
        padLeftZero: function (str) {
            return ('00' + str).substr(str.length);
        },

        //添加购物车
        addShoppingCart: function (id) {
            this.$post('shopping_cart/search', { token: this.$store.state.id, offset: '0', length: '999', shop_id: this.$store.state.store.id }).then(res => {
                let arr = [];
                for (let val of res.data.result.data) {
                    arr.push(Number.parseInt(val.product_id));
                }
                return arr;
            }).then(arr => {
                if (arr.indexOf(Number.parseInt(id)) == -1) {
                    this.$post('shopping_cart/create', { product_id: id, token: this.$store.state.id, shop_id: this.$store.state.store.id }).then(res => {
                        if (res.data.status == 'success') {
                            this.$store.state.shopNum += 1;
                            this.tips = '商品添加成功';
                            UIkit.modal(document.querySelector('#modal-buy')).show();
                        }
                    });
                } else {
                    this.tips = '购物车已经存在该商品，请勿重复添加';
                    UIkit.modal(document.querySelector('#modal-buy')).show();
                }
            })

        },
        //跳转回首页
        goIndex: function () {
            this.$router.push({
                path: '/'
            })
        },
        //获取课程详情的数据
        getData: function () {
            //获取传参的id
            let id = this.$route.query.id;
            //获取课程内容
            this.$post('products/get', { id: id }).then(res => {
                // // console.log(res.data.result);
                document.title = res.data.result.name;
                this.classDetails = res.data.result;
                this.classDetails.id = id;
                return res.data.result.project_id;
            }).then(data => {
                //获取课程章节
                this.$post('projects/search', { id: data }).then(res => {
                    let arr = JSON.parse(res.data.result.resources);
                    let newArr = arr.slice(0, arr.length - 1);
                    let classArr = [];
                    for (let val of newArr) {
                        let obj = {
                            name: val.name,
                            className: val.items
                        };
                        classArr.push(obj)
                    }
                    this.resources = classArr;
                })
            })


        },
        //全部课程跳转
        allClass: function () {
            this.$post('labels/all',{shop_id: this.$store.state.store.id}).then(res => {
                let data = res.data.result;
                this.allLabel(data, this.labels);
                return true;
            }).then(() => {
                for (let item of this.labels.children) {
                    if (item.children) {
                        for (let val of item.children) {
                            this.labelsNoFirst.push(val);
                        }
                    }
                }
                this.$router.push({
                    path: '/blank',
                    query: {
                        lableData: JSON.stringify(this.labelsNoFirst),
                        firstName: '全部',
                        firstId: 0,
                        lableType: 'firstLable',
                    }
                })
            })
        },
        //递归处理返回的标签
        allLabel(data, labelObj) {
            for (let i in data) {
                if (data[i].parent_id === labelObj.id) {
                    if (!labelObj.children) {
                        labelObj.children = [];
                    }
                    labelObj.children.push(data[i]);
                    this.allLabel(data, data[i]);
                }

            }
        },

    },
    mounted: function () {
        this.getData();
    },
}


